module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiSelectPicker"
  }, [_c('overlay-anchor', {
    attrs: {
      "anchor": _vm.anchor,
      "directions": _vm.directions
    },
    on: {
      "positioned": _vm.updatePosition
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: ({
      'max-width': (_vm.windowDimmensions.width - _vm.position.x - 5) + 'px',
      'max-height': (_vm.windowDimmensions.height - _vm.position.y - 5) + 'px'
    })
  }, [_c('ul', {}, _vm._l((_vm.visibleOptions), function(option, index) {
    return _c('li', {}, [(option != _vm.i18n().all) ? _c('span', {
      staticClass: "checkbox",
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [(_vm.isSelected(option)) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.isSelected(option)) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (option == _vm.i18n().all) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [(_vm.liveValue.length == _vm.options.length) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (_vm.liveValue.length != _vm.options.length) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label",
      attrs: {
        "id": 'multiselect-' + _vm.uniq + '-' + index
      },
      on: {
        "click": function($event) {
          _vm.toggle(option)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.display(option)) + "\n        ")])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-627d013d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/MultiSelectPicker.vue
// module id = 452
// module chunks = 0